import * as S from '@effect/schema/Schema'

export const GETSearchCitiesResponse = S.Array(S.Struct({
  id: S.String,
  city: S.String,
  state: S.String,
}))

export type GETSearchCitiesResponse = S.Schema.Type<typeof GETSearchCitiesResponse>
